(function(){
  var CM_TO_IN = 0.393700787;

  // localised decimal separator (31,5 on /it /de /fr /es); toLocaleString also drops a trailing .0
  function fmt(n){ return (Math.round(n * 10) / 10).toLocaleString(document.documentElement.lang || 'en'); }

  function initGuide(root){
    if (root.dataset.sgInit) return;
    root.dataset.sgInit = '1';

    var cells    = root.querySelectorAll('td[data-cm]');
    var unitBtns = root.querySelectorAll('.unit-toggle button[data-unit]');
    var unitWord = root.querySelector('[data-unit-word]');
    var tabs     = root.querySelectorAll('.tab[data-tab]');
    var panels   = root.querySelectorAll('.tab-panel[data-panel]');
    var unit     = 'cm';

    function renderTable(){
      cells.forEach(function(cell){
        var p = cell.getAttribute('data-cm').split(',').map(Number);
        cell.textContent = (unit === 'cm')
          ? p[0] + '–' + p[1]
          : fmt(p[0] * CM_TO_IN) + '–' + fmt(p[1] * CM_TO_IN);
      });
    }

    function setUnit(next){
      unit = next;
      unitBtns.forEach(function(b){
        var on = b.getAttribute('data-unit') === unit;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // translated pages carry their own words in data-cm-word / data-in-word
      if (unitWord) unitWord.textContent = unitWord.getAttribute('data-' + unit + '-word') || ((unit === 'cm') ? 'centimetres' : 'inches');
      renderTable();
    }

    unitBtns.forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        setUnit(b.getAttribute('data-unit'));
      });
    });

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(e){
        e.preventDefault();
        var target = tab.getAttribute('data-tab');
        tabs.forEach(function(t){
          var on = t === tab;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p){
          p.hidden = p.getAttribute('data-panel') !== target;
        });
      });
    });

    renderTable();
  }

  function initAll(){
    document.querySelectorAll('.iwas-sg').forEach(initGuide);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // the PDP modal injects/reveals its content later, so re-scan on open
  document.addEventListener('click', function(){ setTimeout(initAll, 60); }, true);
})();
